import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

var addReactRouterHistoryCommand = function addReactRouterHistoryCommand() {
  Cypress.Commands.add('historyPush', {
    prevSubject: false
  }, function (path, state) {
    cy.window().its('cyHistory').then(function (history) {
      return history.push(path, state);
    });
  });
  Cypress.Commands.add('historyReplace', {
    prevSubject: false
  }, function (path, state) {
    cy.window().its('cyHistory').then(function (history) {
      return history.replace(path, state);
    });
  });
};

var CypressHistorySupport = function CypressHistorySupport() {
  var history = useHistory();
  useEffect(function () {
    if (window.Cypress) {
      window.cyHistory = history;
    }
  }, [history]);
  return null;
};

export { CypressHistorySupport, addReactRouterHistoryCommand };
//# sourceMappingURL=cypress-react-router.esm.js.map
